import logo from './logo.svg';
import './App.css';
import { createHashRouter, RouterProvider, Outlet } from 'react-router-dom';
import { lazy, Suspense } from 'react';

//components
import Home from './components/home/Home'
// import Global from './components/map/Global'
import NotFound from './components/ErrorPages/NotFound';
import SignupRoute from './components/auth/SignupRoute';


//components
import Profile from './components/profile/Profile';
import Transition from './deeplinks/Transition';
import Code from './qrs/Code';
import Empower from './deeplinks/Empower';
import Deeplink from './deeplinks/Deeplink';
import GeoJsonGlobal from './components/map/GeoJsonGlobal';
import APIKey from './components/apikeys/ApiKey';
import { Provider } from 'react-redux';
import UpdateProfile from './components/profile/UpdateProfile';
import EditPass from './components/profile/EditPass';
import Dashboard from './components/dashboard/Dashboard';
import KioskDoc from './components/documentations/WebDoc';
import FlutterDoc from './components/documentations/FlutterDoc';
import AllDocs from './components/documentations/AllDocs';
import DynamicDoc from './components/documentations/DynamicDoc';
import DownloadPage from './components/documentations/DownloadPage';
import DeleteUser from './delete/DeleteUser';
import AppMonitoring from './components/userMonitoring/AppMonitoring';

const Global = lazy(() => import('./components/map/Global'))

  // if(process.env.NODE_ENV === "production" && !window.location.href.includes("developers.iwayplus.in")) window.location.href="https://developers.iwayplus.in"


function App() {



  const baseRoutes = createHashRouter([
    {
      path: '/',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <Profile />
        </Suspense>
      ),
      children: [
        {
          path: "/my-venues",
          element: (
            <Suspense fallback={<h1>Loading...</h1>}>
              <Home />
            </Suspense>
          )
        },
        {
          path: '/',
          element: (
            <Suspense fallback={<h1>Loading...</h1>}>
              <Dashboard />
            </Suspense>
          )
        },
        {
          path: "/geojson/:venueName",
          element: (
            <Suspense fallback={<h1>Loading...</h1>}>
              <GeoJsonGlobal />
            </Suspense>
          )
        },
        {
          path: "/edit-profile",
          element: (
            <Suspense fallback={<h1>Loading...</h1>}>
              <UpdateProfile />
            </Suspense>
          )
        },
        {
          path: '/api-keys',
          element: (
            <Suspense fallback={<h1>Loading...</h1>}>
              <APIKey />
            </Suspense>
          ),
        },
        {
          path: '/app-details',
          element: (
             <Suspense fallback={<h1>Loading...</h1>}>
              <AppMonitoring />
            </Suspense>
          )
        },
        {
          path: '/documentations',
          element: (
            <Suspense fallback={<h1>Loading...</h1>}>
              <Outlet />
              {/* <IwayMapsIntegrationGuide /> */}
            </Suspense>
          ),
          children: [
            {
              path: '/documentations',
              element: (
                <Suspense>
                  <AllDocs />
                </Suspense>
              )
            },
            {
              path: "/documentations/kiosk",
               element: (
                <Suspense>
                  <KioskDoc />
                </Suspense>
              )
            },
            {
              path: '/documentations/navigation-sdk',
              element: (
                <Suspense>
                  <div style={{ boxSizing: 'border-box', width: '99%', height: '100vh', overflow: 'scroll' }}><FlutterDoc /></div>
                </Suspense>
              )
            },
            {
              path: '/documentations/v1/:title',
              element: (
                 <Suspense>
                  <div style={{ boxSizing: 'border-box', width: '80vw', height: '100vh', overflow: 'scroll' }}><DynamicDoc /></div>
                </Suspense>
              )
            }
          ]
        },
        {
          path: "/download/:downloadPath/:version",
          element: (
            <Suspense>
              <DownloadPage />
            </Suspense>
          )
        },
        {
          path: "/change-password",
          element: (
            <Suspense>
              <EditPass />
            </Suspense>
          )
        }
      ],
      errorElement: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <NotFound />
        </Suspense>
      ),
    },
    {
      path: '/iway-apps/:appUrl/:element',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <Transition />
        </Suspense>
      ),
    },
    {
      path: '/empower',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <Empower />
        </Suspense>
      ),
    },
    {
      path: '/:venueName',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <Global />
        </Suspense>
      ),
    },
    // {
    //   path: '/geojson/:venueName',
    //   element: (
    //     <Suspense fallback={<h1>Loading...</h1>}>
    //       <GeoJsonGlobal />
    //     </Suspense>
    //   ),
    // },
    {
      path: '/auth/*',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <SignupRoute />
        </Suspense>
      ),
    },
    {
      path: '/qr/:code',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <Code />
        </Suspense>
      ),
    },
    {
      path: '/delete/user/:appId',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <DeleteUser />
        </Suspense>
      )
    },
    {
      path: '/deeplink/:landmarkId',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <Deeplink />
        </Suspense>
      ),
    },
    {
      path: '*',
      element: (
        <Suspense fallback={<h1>Loading...</h1>}>
          <NotFound />
        </Suspense>
      ),
    },
  ]);

  return (

    <RouterProvider router={baseRoutes} />

  );
}

export default App;
